module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAThJREFUOBHdk79Kw1AUxs8JiooKgi+gCWIhRZzcHXwOF3ETR7f0UkQoTuImfQVHQSk+hLRBRVInwcFFjVZr6fF+wRuuknIzm+Wc+32/83H/ECLHV2v7Vw6EPBdATAsuxh3iStD+fw1R8eLa4ePKdIkrIHDgDZvfyVB4PX1Kzxs3y7PGLKrwwYE3fh5Sr3YbTHzxNui31P3qnAHsCh0+OPDGy0MgqGqyT+KdSvpyeXBdmTcQKtbQ4WecZbLV520UBzs8lC2e4g35kDue5CXpSUs8btbD5DgHf5rCEHgqDrZFZJdIfCLuMvORCpOTvwHZWv8bZ4WGFqNOsBm1/T7qKCabr3X851EAdNdrYf7XxRaF7VVuX4t0W/P0ucdVHM7YYtkeu8T8mN5KU6T3oM/+WXbYcO+DrwnMfwNP6XrVNrJkhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/transctl/img/download.png
// module id = 732
// module chunks = 1